module.exports = __webpack_public_path__ + "img/c06_unitsiegetower_Normal_ua.5f38aea6.webp";